import type { PaymentMode } from '@app/constants/Payment'

import { resolveThunkSelector } from '@app/packages/thunkSelector/thunkSelector'

import { cardResultSelector } from '@app/store/slices/card'
import { profileUserSelector } from '@app/store/slices/profile'
import { createThunk } from '@app/store/thunk'

import { assertMountPush } from '@app/components/Mount/actions'

export function requireCard(_profileSyncHash: string, mode: PaymentMode | null) {
  return createThunk(async (dispatch, getState) => {
    await using stack = new AsyncDisposableStack()

    const user = profileUserSelector(getState())
    if (!user || user.account_type !== 'parent') return true

    const card = await dispatch(resolveThunkSelector(cardResultSelector))
    if (card) return true

    const { promise, resolve } = Promise.withResolvers<boolean>()
    stack.defer(
      await dispatch(
        assertMountPush(
          import('@app/components/Payment/PaymentModal').then(m => m.PaymentModal),
          {
            props: { callback: state => resolve(!!state), mode: mode ?? undefined },
          }
        )
      )
    )
    return await promise
  })
}
